import { Component, Injectable, OnInit, ViewChild } from "@angular/core";
import { DataSharingService } from "src/app/AuthGuard/DataSharingService";
import { ReportsService } from "../services/reports.service";
import { ActivatedRoute } from "@angular/router";
import { QuickLoanService } from "src/app/_QuickLoan/services/quickLoan.service";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableExporterDirective } from "mat-table-exporter";
import { SnackbarComponent } from '../../snackbar/snackbar.component';
import { formatDateForExcel } from 'src/app/Shared/date-utils';
import { MatSnackBarConfig, MatSnackBar } from '@angular/material/snack-bar';

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

const EXCEL_TYPE =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const EXCEL_EXTENSION = ".xlsx";
@Injectable()
// Excel export code end here
@Component({
  selector: "app-reports-disburs-collection",
  templateUrl: "./reports-disburs-collection.component.html",
  styleUrls: ["./reports-disburs-collection.component.scss"],
  standalone: false
})
export class ReportsDisbursCollectionComponent implements OnInit {
  formatDateForExcel = formatDateForExcel;
  showSpinner: boolean = false;
  FromDate: any = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
  ToDate: any = new Date();
  dataSource: any;
  currentUser: any;
  configSuccess: MatSnackBarConfig = {
    panelClass: 'style-success',
    duration: 5000,
    horizontalPosition: 'right',
    verticalPosition: 'top'
  };
  displayedColumns: any[];
  JsonData: any[] = [];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild("exporter", { static: true })
  matTableExporter: MatTableExporterDirective;
  selectedId: any;
  constructor(
    private dataSharingService: DataSharingService,
    private reportsService: ReportsService,
    private route: ActivatedRoute,
    private quickLoanService: QuickLoanService,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
    this.dataSharingService.HeaderTitle.next("Disburse Collection");
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
  }

  onSearchDisbursCollcetionReport() {
    this.showSpinner = true;

    this.reportsService
      .Report_Bumchum({
        FromDate: this.FromDate,
        Todate: this.ToDate,
      })
      .subscribe((res: any) => {
        console.log("ressss", res);
        if (res.length > 0) {
          this.displayedColumns = [
            "Loan_Id",
            "CIFNo",
            "Application_No",
            "Application_Date",
            "LoanAcNo",
            "Loan_Date",
            "FirstEMIDate",
            "ExpiryDate",
            "Product_Name",
            "Branch_Name",
            "Customer_Name",
            "Customer_Gender",
            "Customer_DOB",
            "Customer_PhoneNo",
            "Customer_Email",
            "Customer_Other_Email",
            "AadharNo",
            "PAN_No",
            "Bank_AccountNo",
            "IFSCCode",
            "Bankname",
            "Bank_Branch",
            "AccType",
            "LoanAmount",
            "Installment_Amount",
            "Tenure",
            "AgreementAmount",
            "Frequency",
            "Interest_Rate",
            "TotalDeduction",
            "TotalDeductionGST",
            "ToBeDisbursment",
            "NetDisbursment",
            "PendingDisbursement",
            "Last_Pay_Date",
            "InstalmentDue",
            "InstalmentReceived",
            "InstalmentBalance",
            "Last_Recdved_Date",
            "Day_Use",
            "Accrued_Interest",
            "Accrued_Balance",
            "FI_By",
            "CreditRecomdationBy",
            "CreaditApprovedBy",
            "Collection_Executive",
            "ApplicationCreateBy"
          ];

          this.JsonData = JSON.parse(JSON.stringify(res));

          this.dataSource = new MatTableDataSource(
            JSON.parse(JSON.stringify(res))
          );
          this.dataSource.paginator = this.paginator;
          this.showSpinner = false;
        } else {
          this.snackBar.
            openFromComponent(SnackbarComponent,
              { data: "No Data Found", ...this.configSuccess });
          this.showSpinner = false;
        }
      });
  }
  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  totaltypewise(type) {
    if (this.dataSource != null) {
      let sum = 0;
      for (let i = 0; i < this.dataSource.filteredData.length; i++) {
        sum += Number(this.dataSource.filteredData[i][type]);
      }
      return sum > 0 ? sum.toFixed(2) : 0;
    }
    return 0;
  }

  exportExcel(): void {
    const uri = "data:application/vnd.ms-excel;base64,";
    const template =
      '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>';
    const base64 = (s: string): string =>
      window.btoa(unescape(encodeURIComponent(s)));
    const format = (s: string, c: { [key: string]: string }): string =>
      s.replace(/{(\w+)}/g, (m, p) => c[p]);

    const table = document.getElementById("disburse_collection") as HTMLTableElement;
    const worksheetName = "REPORT DISBURSE COLLECTION"; // Set the desired worksheet name here
    const ctx = { worksheet: worksheetName, table: table.innerHTML };
    const downloadLink = document.createElement("a");

    // Generate the data URI for the Excel file
    downloadLink.href = uri + base64(format(template, ctx));

    // Set the file name for the download
    downloadLink.download = worksheetName + ".xls";

    // Trigger the download
    downloadLink.click();
  }

  public highlightRow(row) {
    this.selectedId = row.Loan_Id;
  }
}
